/* NESCENTCITY — cart drawer
   Live re-render via the Section Rendering API. Quantity steppers, line
   removal, one-tap upsells, the shipping-protection toggle and the
   auto free-gift all update the drawer in place — no page reloads. */
(function () {
  'use strict';

  var SECTION = 'cart-drawer';
  var busy = false;

  function wrapper() {
    return document.getElementById('shopify-section-' + SECTION);
  }

  function isOpen() {
    var d = document.getElementById('drawer-cart');
    return d && d.classList.contains('is-open');
  }

  function rerender(keepOpen) {
    return fetch(window.location.pathname + '?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var w = wrapper();
        if (!w || !data[SECTION]) return;
        var open = keepOpen || isOpen();
        var tmp = document.createElement('div');
        tmp.innerHTML = data[SECTION];
        var fresh = tmp.querySelector('#drawer-cart');
        var freshScrim = tmp.querySelector('.cd__scrim');
        var cur = document.getElementById('drawer-cart');
        var curScrim = w.querySelector('.cd__scrim');
        if (fresh && cur) {
          if (open) {
            fresh.classList.add('is-open');
            fresh.setAttribute('aria-hidden', 'false');
          }
          cur.replaceWith(fresh);
        }
        if (freshScrim && curScrim) {
          freshScrim.hidden = !open;
          curScrim.replaceWith(freshScrim);
        }
        if (open) document.body.style.overflow = 'hidden';
        if (typeof window.NSCRefreshCart === 'function') window.NSCRefreshCart();
        setTimeout(syncGift, 60);
      });
  }

  window.NSCRerenderCart = rerender;
  document.addEventListener('nsc:cart-changed', function () { rerender(true); });

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed');
      return r.json();
    });
  }

  /* Auto-add / auto-remove the free mystery gift at the threshold, so the
     gift is always a real line in the order and never missed when packing. */
  function syncGift() {
    if (busy) return;
    var box = document.querySelector('#drawer-cart [data-cart-items]');
    if (!box) return;
    var vid = parseInt(box.getAttribute('data-gift-vid'), 10);
    if (!vid) return;
    var threshold = parseInt(box.getAttribute('data-gift-threshold'), 10) || 0;
    var merch = parseInt(box.getAttribute('data-merch'), 10) || 0;
    var inCart = box.getAttribute('data-gift-in') === '1';
    var qualifies = threshold > 0 && merch >= threshold;
    if (qualifies === inCart) return;
    busy = true;
    var req = qualifies
      ? post((window.NSC && window.NSC.cartAddUrl) || '/cart/add.js', { id: vid, quantity: 1 })
      : post('/cart/update.js', { updates: (function (o) { o[vid] = 0; return o; })({}) });
    req.then(function () { return rerender(true); })
      .catch(function () {})
      .finally(function () { busy = false; });
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(syncGift, 200); });

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('#drawer-cart [data-qty-minus]');
    var plus = e.target.closest('#drawer-cart [data-qty-plus]');
    var remove = e.target.closest('#drawer-cart [data-line-remove]');
    var upsell = e.target.closest('[data-upsell-add]');

    if (upsell) {
      e.preventDefault();
      if (busy) return;
      busy = true;
      upsell.textContent = '…';
      post((window.NSC && window.NSC.cartAddUrl) || '/cart/add.js', {
        id: parseInt(upsell.getAttribute('data-vid'), 10), quantity: 1
      })
        .then(function () { return rerender(true); })
        .catch(function () { upsell.textContent = 'Add'; })
        .finally(function () { busy = false; });
      return;
    }

    if (!minus && !plus && !remove) return;
    e.preventDefault();
    if (busy) return;
    var row = e.target.closest('[data-line]');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var qty;
    if (remove) {
      qty = 0;
    } else {
      var cur = parseInt(row.querySelector('.cd__qty span').textContent, 10) || 1;
      qty = cur + (plus ? 1 : -1);
      if (qty < 0) qty = 0;
    }
    busy = true;
    post((window.NSC && window.NSC.cartChangeUrl) || '/cart/change.js', { line: line, quantity: qty })
      .then(function () { return rerender(true); })
      .finally(function () { busy = false; });
  });

  /* shipping protection toggle */
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-protect-toggle]');
    if (!t || busy) return;
    busy = true;
    var vid = parseInt(t.getAttribute('data-vid'), 10);
    var req;
    if (t.checked) {
      req = post((window.NSC && window.NSC.cartAddUrl) || '/cart/add.js', { id: vid, quantity: 1 });
    } else {
      req = post('/cart/update.js', { updates: (function (o) { o[vid] = 0; return o; })({}) });
    }
    req.then(function () { return rerender(true); })
      .finally(function () { busy = false; });
  });
})();
